export const callFeatureKey = 'call';

export type CallDirection = 'Inbound' | 'Outbound';
export type CallOutcome =
  | 'Served'
  | 'ClosedOffices'
  | 'Voicemail'
  | 'AbandonedInReceptionist'
  | 'AbandonedInQueue'
  | 'DirectLineUnanswered'
  | 'ForwardedOutside'
  | 'NoAgentAvailable'
  | 'Reached'
  | 'NotReached'
  | 'InvalidNumber';

export type CallTabDetailsListItem = {
  id: number;
  contactId?: number | null;
  /** Filter key of the lead tab, which reads by phone number; not displayed. */
  clientNumberMatchKey: string;
  startDate: Date;
  direction: CallDirection;
  directionLoc: string;
  directionColor: string;
  agentUserContactName: string;
  agentName: string;
  agentDisplayName: string;
  clientNumber: string;
  talkingDurationSeconds: number;
  waitingDurationSeconds: number;
  /** Talking time, or waiting time for an unserved call (never both); computed server-side. */
  durationSeconds: number;
  outcome: CallOutcome;
  outcomeLoc: string;
  outcomeColor: string;
};
